import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Input,
  RadioGroup,
  MultiAutocomplete,
} from '~/components/Form';
import { t } from '~/helpers';

function RelMovimentacaoManualParaIntegracao() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [valuePosto, setValuePosto] = React.useState([]);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);

    return {
      ...params,
      idposto: idPosto,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.movimentacaointegrada')}
      relatorio="relmovimentacaomanualparaintegracao"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto !== null) {
            setPosto(value);
            setValuePosto(value);
          } else {
            setPosto([]);
            setValuePosto([]);
          }
        }}
      />

      <Input
        name="idveiculo"
        number
        label={t('s.operacao.abastecimento.idveiculo')}
      />

      <Input
        name="codigoatendimento"
        label={t('s.cadastro.pitstop.codigoatendimento')}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelMovimentacaoManualParaIntegracao;
